import React from 'react';
import { type EventFilter, EventStatus } from '@/types/event';

interface EventFilterProps {
  currentFilter: EventFilter;
  onFilterChange: (filter: EventFilter) => void;
}

const EventFilter: React.FC<EventFilterProps> = ({ currentFilter, onFilterChange }) => {
  const handleStatusChange = (status: EventStatus | 'ALL') => {
    onFilterChange({
      ...currentFilter,
      status: status,
    });
  };

  return (
    <div data-component-id="src/components/events/EventFilter.tsx:18:4" data-component-path="src/components/events/EventFilter.tsx" data-component-line="18" data-component-end-line="59" data-component-file="EventFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20mx-auto%20gap-2%20mb-8%20bg-red-100%20p-2%20rounded-2xl%20w-fit%22%7D" className="flex justify-center mx-auto gap-2 mb-8 bg-red-100 p-2 rounded-2xl w-fit">
      <button data-component-id="src/components/events/EventFilter.tsx:19:6" data-component-path="src/components/events/EventFilter.tsx" data-component-line="19" data-component-end-line="28" data-component-file="EventFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22textContent%22%3A%22T%E1%BA%A5t%20C%E1%BA%A3%22%7D"
        className={`px-6 py-2 rounded-2xl transition-colors ${
          currentFilter.status === 'ALL' || !currentFilter.status
            ? 'bg-red-400 text-white'
            : 'bg-white text-[#4A306D] hover:bg-gray-100'
        }`}
        onClick={() => handleStatusChange('ALL')}
      >
        Tất Cả
      </button>
      <button data-component-id="src/components/events/EventFilter.tsx:29:6" data-component-path="src/components/events/EventFilter.tsx" data-component-line="29" data-component-end-line="38" data-component-file="EventFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22textContent%22%3A%22S%E1%BA%AFp%20Di%E1%BB%85n%20Ra%22%7D"
        className={`px-6 py-2 rounded-2xl transition-colors ${
          currentFilter.status === EventStatus.UPCOMING
            ? 'bg-red-400 text-white'
            : 'bg-white text-[#4A306D] hover:bg-gray-100'
        }`}
        onClick={() => handleStatusChange(EventStatus.UPCOMING)}
      >
        Sắp Diễn Ra
      </button>
      <button data-component-id="src/components/events/EventFilter.tsx:39:6" data-component-path="src/components/events/EventFilter.tsx" data-component-line="39" data-component-end-line="48" data-component-file="EventFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22textContent%22%3A%22%C4%90ang%20Di%E1%BB%85n%20Ra%22%7D"
        className={`px-6 py-2 rounded-2xl transition-colors ${
          currentFilter.status === EventStatus.LIVING
            ? 'bg-red-400 text-white'
            : 'bg-white text-[#4A306D] hover:bg-gray-100'
        }`}
        onClick={() => handleStatusChange(EventStatus.LIVING)}
      >
        Đang Diễn Ra
      </button>
      <button data-component-id="src/components/events/EventFilter.tsx:49:6" data-component-path="src/components/events/EventFilter.tsx" data-component-line="49" data-component-end-line="58" data-component-file="EventFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22textContent%22%3A%22%C4%90%C3%A3%20K%E1%BA%BFt%20Th%C3%BAc%22%7D"
        className={`px-6 py-2 rounded-2xl transition-colors ${
          currentFilter.status === EventStatus.ENDED
            ? 'bg-red-400 text-white'
            : 'bg-white text-[#4A306D] hover:bg-gray-100'
        }`}
        onClick={() => handleStatusChange(EventStatus.ENDED)}
      >
        Đã Kết Thúc
      </button>
    </div>
  );
};

export default EventFilter;
